<script lang="ts">
	import type { Procedure } from "@core/schema/Procedure.js";
	import { homepageData } from "../../data/homepageData.js";
	import { homepageImages } from "../../data/homepageImages.js";
	import Media from "../common/Media.svelte";
	import SimpleSlideshow from "../common/SimpleSlideshow.svelte";

	const { procedure }: { procedure?: Procedure } = $props();

	const processSteps = homepageData.processCarouselImages.map((item) => {
		const img = homepageImages[item.imageKey as keyof typeof homepageImages];
		return {
			image: typeof img === "string" ? { mobile: img, desktop: img } : img,
			imageAlt: item.imageAlt,
		};
	});

	const duplicatedSteps = [...processSteps, ...processSteps];
</script>

<section class="full-width flex flex-col gap-4 md:gap-8">
	<!-- <h2>
		<Formatted text={homepageData.processStepsHeading} />
	</h2> -->

	<SimpleSlideshow class={["full-width"]} flowDirection="left" forceSlidingOnMobile>
		{#if procedure?.images && procedure.images.length > 0}
			{#each procedure.images as image, index (index)}
				<div class="basis-[20rem] md:basis-[28rem] lg:basis-[35rem] xl:basis-[39.375rem] flex-shrink-0 px-2">
					<Media
						source={image}
						alt={procedure.title}
						width={400}
						height={300}
						class="w-full h-[12rem] md:h-[16rem] lg:h-[22rem] xl:h-[26.25rem] object-cover rounded-[2rem] md:rounded-[4rem] lg:rounded-[6rem] xl:rounded-[8rem]"
						eager
						sourcesets={{}}
						lightbox="process-gallery"
					/>
				</div>
			{/each}
		{:else}
			{#each duplicatedSteps as step, index (`${step.imageAlt}-${index}`)}
				<div class="basis-[20rem] md:basis-[28rem] lg:basis-[35rem] xl:basis-[39.375rem] flex-shrink-0 px-2">
					<Media
						source={{ src: String(step.image.desktop), type: "image" }}
						sourcesets={{
							"<md": String(step.image.mobile),
							">md": String(step.image.desktop),
						}}
						alt={step.imageAlt}
						width={400}
						height={300}
						class="w-full h-[12rem] md:h-[16rem] lg:h-[22rem] xl:h-[26.25rem] object-cover rounded-[2rem] md:rounded-[4rem] lg:rounded-[6rem] xl:rounded-[8rem]"
						eager
						lightbox="process-gallery"
					/>
				</div>
			{/each}
		{/if}
	</SimpleSlideshow>
</section>
